import type { ApiMagentoPurchaseType } from "@jti/magento-types";

import type {
  ConsumableMatrixItem,
  ConsumablesMatrixData,
} from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

import { getMatrixItemsByPackagingFormat } from "../getMatrixItemsByPackagingFormat";
import { getMatrixItemsByPurchaseType } from "../getMatrixItemsByPurchaseType";

export const getMatrixItemForNextAvailablePackagingFormat = (
  matrixData: ConsumablesMatrixData,
  currentPackagingFormatId: string,
  purchaseType: ApiMagentoPurchaseType,
  flavorId: number | string | null
): ConsumableMatrixItem | null => {
  const { packagingFormats } = matrixData;
  const matrixItemsWithPurchaseType = getMatrixItemsByPurchaseType(matrixData, purchaseType);

  const currentFormatPosition = packagingFormats.findIndex((format) => format.id === currentPackagingFormatId);

  const formatsInSearchOrder = [
    ...packagingFormats.slice(currentFormatPosition + 1),
    ...packagingFormats.slice(0, currentFormatPosition + 1),
  ];

  for (const packagingFormat of formatsInSearchOrder) {
    const matrixItemsWithNextFormat = getMatrixItemsByPackagingFormat(matrixItemsWithPurchaseType, packagingFormat.id);

    if (!matrixItemsWithNextFormat.length) {
      continue;
    }

    const nextMatrixItemWithSameFlavor = flavorId
      ? matrixItemsWithNextFormat.find((item) => item.flavorDetails?.flavour === flavorId)
      : undefined;

    return nextMatrixItemWithSameFlavor ?? matrixItemsWithNextFormat[0];
  }
  return null;
};
